import { createWebHistory, createRouter } from "vue-router";
/*import Home from "@/views/Home.vue";
import About from "@/views/About.vue";
import Prix from "@/views/Prix.vue";
import HistChart from "@/views/HistChart.vue";
import QRforU from "@/views/QRforU.vue"
import Leasingkollen from '@/views/Leasingkollen.vue'
import Privacy from '@/views/Privacy.vue'*/
import Index from '@/views/Index.vue'

const routes = [
  {
    path: "/",
    name: "Index",
    component: Index,
  }
  /*{
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    component: About,
  },
  {
    path: "/historicalCharts",
    name: "HistoricalCharts",
    component: HistChart,
  },
  {
    path: "/prix",
    name: "Prix",
    component: Prix,
  },
  {
    path: "/qrforu",
    name: "QRforU",
    component: QRforU,
  },
  {
    path: "/leasingkollen",
    name: "Leasingkollen",
    component: Leasingkollen,
  },
  {
      path: "/leasingkollen/privacy",
      name: "Privacy",
      component: Privacy}*/
];
const router = createRouter({
    history: createWebHistory(),
    routes,
  });
  
  export default router;